import PropTypes from 'prop-types';
import React from 'react';

import { Body } from '@nerdwallet/currency';
import { AB, Variant, Control } from '@nerdwallet/features';
import styles from './hero-nav-tile.module.less';

const HeroNavTile = (props) => {
  const makeTile = ({
    nav,
    IconComponent,
    iconColor,
    backgroundColor,
    url,
  }) => {
    return (
      <a href={url} className={styles.container}>
        <div className={styles.tile}>
          <div style={{ backgroundColor }} className={styles.iconContainer}>
            <IconComponent
              color={iconColor}
              size={48}
              className={styles.iconComponent}
            />
          </div>
          <Body className={styles.text}>{nav}</Body>
        </div>
      </a>
    );
  };

  if (props.nav === 'Mortgages') {
    return (
      <div className={styles.gridSpacing}>
        <AB testName="welcome_front_page_mort_tile">
          <Control>
            {makeTile({
              ...props,
              url:
                '/hub/category/mortgages?trk=hp_tiles_bestmortgage&trk_copy=hpbestmortgage_cntrl',
            })}
          </Control>
          <Variant name="best_mort_lenders">
            {makeTile({
              ...props,
              url:
                '/mortgages/best-mortgage-lenders?trk=hp_tiles_bestmortgage&trk_copy=hpbestmortgage_var',
            })}
          </Variant>
        </AB>
      </div>
    );
  }

  return makeTile(props);
};

HeroNavTile.propTypes = {
  nav: PropTypes.string,
  IconComponent: PropTypes.elementType,
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  url: PropTypes.string,
};

HeroNavTile.displayName = 'HeroNavTile';

export default HeroNavTile;
